'use client';

import { VStack } from '@terra/ui-styled-system';
import { File01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { EmptyState } from '../EmptyState';
import { RequestsFilterBar } from './RequestsFilterBar';

type RequestsFilterEmptyStateProps = {
  tqlQuery: string;
  setTqlQuery: (query: string) => void;
  filterMode: 'simple' | 'advanced';
  setFilterMode: (mode: 'simple' | 'advanced') => void;
  isSearching: boolean;
};

export function RequestsFilterEmptyState({
  tqlQuery,
  setTqlQuery,
  filterMode,
  setFilterMode,
  isSearching,
}: RequestsFilterEmptyStateProps) {
  const t = useTranslations('httpHistory.emptyFilter');

  return (
    <VStack h="full" w="full" gap="0">
      <RequestsFilterBar
        tqlQuery={tqlQuery}
        setTqlQuery={setTqlQuery}
        filterMode={filterMode}
        setFilterMode={setFilterMode}
        showScopeControls={false}
      />
      <EmptyState
        icon={File01Icon}
        title={isSearching ? t('filtering') : t('noMatching')}
        description={t('description')}
        isLoading={isSearching}
      />
    </VStack>
  );
}
